import { Loader2 } from 'lucide-react';
import { statusLabel } from '../lib/format';
import type { Campaign } from '../lib/supabase';

interface Props { status: Campaign['status']; }

export function StatusBadge({ status }: Props) {
  return (
    <span className={`status-badge status-${status}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      {status === 'sending' && <Loader2 size={11} className="spin" aria-hidden="true" />}
      {statusLabel(status)}
    </span>
  );
}
